(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Util = require('./modules/utils');
var Theme = require('./modules/theme');
var InfiniteScroll = require('./modules/infinite-scroll');
var MobileMenu = require('./modules/mobile-menu');
var InViewClass = require('./modules/in-view-class');
var Accordion = require('./modules/accordion');
var Shortcuts = require('./modules/shortcuts');

jQuery(document).ready(function ($) {

	Util.detectBrowser(); // Adds Browser Version and OS as a class to HTML

	Theme.init();

	InifiteScroll.init();

	MobileMenu.init();

	InViewClass.init('.row');

	$('[data-accordion]').accordion();
	$('[data-accordion-toggle]').accordionToggle();

	Shortcuts.init();

});

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_3db43ebb.js","/")